<template>
    <div class="products_in">
        <div class="button_add mb-4">
            <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_prod()">
                <span class="fal  fa-eject mr-1"></span>
                {{__t('SELECT_PRODUCT')}}
            </button>
        </div>

        <div class="form-group mt-2">
            <label class="form-label" for="bolt_rest">
                {{__t("LOCATION_ADD_PRODUCT")}}
            </label>

            <div class="" v-if="this.active_products.length > 0">
                <div class="special_items card p-2" v-for="prod in this.active_products">
                    <div class="d-flex flex-row align-items-center p-2" >
                          <span class="position-absolute remove" v-on:click.stop.prevent="remove_item(prod)" >
                              <span  class="btn btn-danger btn-sm btn-icon waves-effect waves-themed">
                                  <i class="fal fa-times"></i>
                              </span>
                        </span>

                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-address-book icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3">

                            <strong>
                                {{prod.title}} | {{ "Price:" + prod.price}}
                            </strong>
                            <br>
                            {{prod.product_code}}
                        </div>
                    </div>

                    <div class="d-block" v-if="labels.length > 0">
                        <v-select
                            v-model="prod.type"
                            class="imc_reasons"
                            @input="work_labels"
                            :reduce="label => label.type"
                            label="title"
                            :options="labels"
                            :filterable="false"
                            :clearable="false"
                        >
                            <template slot="no-options">
                                {{__t('PROD_ADD_TYPE')}}
                            </template>

                            <template slot="option"  slot-scope="option">
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>


        <product_modal_list
            :selected_ids="active_products_ids"
            :is_multiple=true>
        </product_modal_list>
    </div>
</template>

<script>
import product_modal_list from "../../../../catalog/products/modal_list/product_modal_list";
import vSelect from 'vue-select'
export default {
    name: "location_products",
    props : {
        location : {
            type : Object
        }
    },
    components : {
        product_modal_list,
        vSelect
    },

    data() {
        return {
            is_load: false,
            products : [],
            is_set_data : false,
        }
    },
    created() {
        EventBus.$on('selected_prod', this.set_prod);
        EventBus.$on('select_product_list_modal', this.set_prods);
    },

    beforeDestroy() {
        EventBus.$off('selected_prod',this.set_prod);
        EventBus.$off('select_product_list_modal', this.set_prods);

    },
    methods : {
        work_labels(cur_val) {
            console.log('SET_PROD_TYPE',cur_val);
        },


        set_prods(prods) {
            console.log(prods);
            let current_active = JSON.parse(JSON.stringify(this.active_products));

            this.active_products = [];
            if(prods.length > 0) {
                prods.map(item => {
                    let to_push = {
                        'product_code' : item.product_code,
                        'product_id' : item.id,
                        'price' : item.price,
                        'title' : item.title,
                    };

                    try {
                        current_active.map(function (item) {
                            if (parseInt(item.product_id) === parseInt(to_push.product_id)) {
                                to_push.type = item.type;
                            }
                        });
                    }
                    catch (e) {

                    }


                    this.active_products.push(to_push);
                })
            }
        },


        set_prod(cur_prod) {

            this.active_products.push({
                'product_code' : cur_prod.product_code,
                'product_id' : cur_prod.id,
                'price' : cur_prod.price,
                'title' : cur_prod.title,
                'type' : "add",
            });
        },

        add_prod() {
            EventBus.$emit('select_product_modal');
        },

        remove_item(prod) {
            console.log('remove',prod);
            /*for(let i = 0; i < this.active_products.length; i++) {
                if(parseInt(this.active_products[i].product_id) ==  parseInt(prod.product_id)) {
                    this.active_products.splice(i,1);
                }
            }*/


            this.active_products = this.active_products.filter(item => {
                return parseInt(item.product_id) != parseInt(prod.product_id);
            });
        }
    },
    computed : {

        labels () {
            let types = [
                'add',
                'delivery',
                'service_fee',
                'small_order',
                'tips',
                'up_sale'
            ];

            return types.map(type => {
                return  {
                    'type' :  type,
                    'title' : this.__t('ORDER_'+ type.toUpperCase())
                }
            });

        },

        active_products : {
            get :function () {
                let res = [];
                if(this.location.hasOwnProperty("attached_products")) {
                    return this.location.attached_products;
                }
                return res;
            },
            set: function (val) {
                if(this.location.hasOwnProperty("attached_products")) {
                    this.location.attached_products = val;
                }
            }
        },
        active_products_ids () {
            try {
                return this.active_products.map((item => {
                    return parseInt(item.product_id);
                }));
            }
            catch (e) {

            }

            return [];
        }
    }
}
</script>

<style scoped>
.remove {
    right: 25px;
}
</style>
